import type { Platform } from '../types';
import { PLATFORM_LABEL } from '../types';

// Source images are at different native sizes (Google 100x100, Microsoft 50x50). We render at
// the same explicit pixel size so they appear visually equivalent.
// PRODUCTION: consider bundling these locally (or as SVG) instead of hot-linking the CDN.
const ICON_URL: Record<Platform, string> = {
  google_ads: 'https://cdn.blisspointmedia.com/assets/img/platforms/GoogleAds.png',
  microsoft_ads: 'https://cdn.blisspointmedia.com/assets/img/platforms/MicrosoftAds.png'
};

interface PlatformIconProps {
  platform: Platform;
  size?: number;
}

export const PlatformIcon = ({ platform, size = 14 }: PlatformIconProps) => (
  <img
    className='platform-icon'
    src={ICON_URL[platform]}
    alt={`${PLATFORM_LABEL[platform]} Ads logo`}
    width={size}
    height={size}
  />
);
